var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "homeIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 282",
    transform: "translate(39 46)",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h54v54H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "homeIcon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 283",
    fill: "none",
    d: "M0 0h54v54H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "HomeIcon",
    transform: "translate(-39 -46)",
    clipPath: "url(#homeIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "HomeIcon",
    transform: "translate(39 46)",
    clipPath: "url(#homeIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 310"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 326",
    d: "M26.634 5.37L.75 26.528h12.406v22.1h8.073V36.09a5.775 5.775 0 0111.541 0v12.54h8.08v-22.1h12.4z",
    fill: "#040000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.bfe1d65dd848fe48.svg";
export { ForwardRef as ReactComponent };